import React from 'react';
import { ArrowRight, ShieldCheck } from 'lucide-react';
interface HeroProps {
  onScrollToPrice: () => void;
}
export function Hero({
  onScrollToPrice
}: HeroProps) {
  return <div className="relative bg-gradient-to-b from-slate-900 to-slate-800 text-white pb-16 overflow-hidden" data-id="element-143">
      {/* Urgency Bar */}
      <div className="bg-red-600 text-white text-center py-2 px-4 font-bold text-sm md:text-base animate-pulse" data-id="element-144">
        ⏳ OFERTA POR TIEMPO LIMITADO | 🔥 CUPOS DISPONIBLES HOY
      </div>

      <div className="max-w-5xl mx-auto px-4 pt-8 md:pt-12 text-center" data-id="element-145">
        {/* Pre-headline */}
        <p className="text-yellow-400 font-bold tracking-wider uppercase mb-4 text-sm md:text-base" data-id="element-146">
          📐 Para madres y padres de niños de 2 a 12 años
        </p>

        {/* Headline */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-black mb-6 leading-tight tracking-tight" data-id="element-147">
          <span className="text-white" data-id="element-148">CRIANZA</span>{' '}
          <span className="text-yellow-400" data-id="element-149">SIN CELULAR</span>
        </h1>

        {/* Product Image */}
        <div className="relative mx-auto max-w-[500px] mb-8 group cursor-pointer" onClick={onScrollToPrice} data-id="element-150">
          <div className="absolute -inset-1 bg-yellow-400 rounded-2xl blur opacity-20 group-hover:opacity-40 transition duration-1000" data-id="element-151"></div>
          <img src="https://cdn.magicpatterns.com/uploads/qhpoymFMaZpWfB19SkmAch/Diseno_sin_titulo_(16).png" alt="Crianza Sin Celular Pack" className="relative rounded-xl shadow-2xl w-full transform group-hover:scale-105 transition duration-500" data-id="element-152" />
        </div>

        {/* Subheadline */}
        <h2 className="text-xl md:text-3xl font-bold text-gray-200 mb-6 max-w-3xl mx-auto leading-snug" data-id="element-153">
          El programa completo para que el celular deje de criar a tus hijos
        </h2>

        {/* Description */}
        <p className="text-lg md:text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-154">
          Todo lo que necesitás para reducir pantallas, recuperar la conexión
          familiar y criar con límites sanos, sin gritos ni culpa.
        </p>

        {/* CTA */}
        <button onClick={onScrollToPrice} className="w-full md:w-auto bg-red-600 hover:bg-red-500 text-white text-xl md:text-2xl font-bold py-4 px-10 rounded-full shadow-[0_4px_14px_0_rgba(220,38,38,0.39)] hover:shadow-[0_6px_20px_rgba(220,38,38,0.23)] hover:-translate-y-1 transition-all flex items-center justify-center gap-2 mx-auto" data-id="element-155">
          👉 SÍ, QUIERO ACCEDER AHORA
        </button>

        {/* Guarantee */}
        <div className="mt-6 flex items-center justify-center gap-2 text-sm text-gray-400" data-id="element-156">
          <ShieldCheck className="w-5 h-5 text-green-500" data-id="element-157" />
          <span data-id="element-158">Garantía de satisfacción de 7 días</span>
        </div>
      </div>
    </div>;
}